import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { usePrefix } from '../../internal/usePrefix';

var SkeletonIcon = function SkeletonIcon(_ref) {
  var _classNames;

  var className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded);

  var prefix = usePrefix();
  var skeletonIconClasses = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefix, "--icon--skeleton"), true), _defineProperty(_classNames, className, className), _classNames));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: skeletonIconClasses
  }, other));
};

SkeletonIcon.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,

  /**
   * The CSS styles.
   */
  style: PropTypes.object
};
export default SkeletonIcon;